export class ObstacleEffect extends window.SpinePlugin.SpineGameObject {
  protected isInUse: boolean;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, scene.sys.spine, x, y, 'effect');

    this.isInUse = false;
  }

  get IsInUse() {
    return this.isInUse;
  }

  public init() {
    this.isInUse = false;
  }

  public setTargetObstacle(skin: string, animation: string, shouldLoop: boolean) {
    this.isInUse = true;
    this.setSkinByName(skin);
    this.setAnimation(0, animation, shouldLoop);
    this.refresh();

    this.once('complete', () => {
      this.scene.add.tween({
        targets: this,
        alpha: 0,
        duration: 250,
        ease: Phaser.Math.Easing.Circular.InOut,
        delay: 500,
        completeDelay: 500,
        onComplete: () => {
          this.recycle();
        },
        onCompleteScope: this
      });
    });
  }

  public recycle() {
    this.alpha = 1;
    // this.setActive(false);
    this.setVisible(false);
    this.isInUse = false;
    this.clearTracks();
  }
}
